import { getName } from 'country-list';
import { CountrySortColumn, SortOrder, CountryListItem } from './types';

export const prepareCountriesList = (
  countries: Array<{ countryCode: string; number: number }>,
  sortBy: CountrySortColumn = 'countryName',
  sortOrder: SortOrder = 'ASC',
) => {
  let countriesWithNames = countries.map(
    item =>
      ({
        ...item,
        countryName: getName(item.countryCode),
      } as CountryListItem),
  );

  if (countriesWithNames.length > 1) {
    countriesWithNames = countriesWithNames.sort((a: any, b: any) => {
      // eslint-disable-next-line no-nested-ternary
      return a[sortBy] > b[sortBy] ? 1 : b[sortBy] > a[sortBy] ? -1 : 0;
    });
  }
  if (sortOrder === 'DESC') {
    countriesWithNames.reverse();
  }

  return countriesWithNames;
};
